import apis from '@/pages/data-panel/flow-insight/apis';

const UPDATA_ACTIVITY_INFO = 'UPDATA_ACTIVITY_INFO';
const REPORT_ACTIVITY_ROOMLIST = 'REPORT_ACTIVITY_ROOMLIST';
const UPDATA_REPORT_PARAM = 'UPDATA_REPORT_PARAM';
const RESET_REPORT_PARAM = 'ESET_REPORT_PARAM';
export const updataReportParam = (param) => (dispatch, getState) => {
  // console.log('更新', param)
  dispatch({
    type: UPDATA_REPORT_PARAM,
    payload: param,
  });
};

export const reportActivityRoomList = (param) => (dispatch, getState) => {
  apis.activityRoomList(param).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: REPORT_ACTIVITY_ROOMLIST,
        payload: res.data,
      });
    } else {
      dispatch({
        type: REPORT_ACTIVITY_ROOMLIST,
        payload: {},
      });
    }
  });
};

export const updataActivityInfo = (param) => (dispatch, getState) => {
  dispatch({
    type: UPDATA_ACTIVITY_INFO,
    payload: param,
  });
};

export const resetData = () => (dispatch, getState) => {
  dispatch({
    type: RESET_REPORT_PARAM,
  });
};
const initialState = {
  totalPage: 0,
  totalCount: 0,
  // 活动列表
  activityPlans: [],
  loading: false,
  // 会场列表
  list: [],
  queryConditions: {},
  roomList: [],
  qualityAnalysis: {},
  userAnalysis: {},
  channelList: [],
  flowName: {},
  selectIndex: -1,
  loadingStatus: false,
  // 当前选中的活动名称
  currentActivityInfo: {
    name: {
      customize: '',
      activityName: '',
      time: '',
      planCode: '',
      startTime: '',
      endTime: '',
      timeTips: '',
    },
  },
};
export default function dataReport(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case UPDATA_REPORT_PARAM:
      return Object.assign({}, state, { queryConditions: payload });
    case REPORT_ACTIVITY_ROOMLIST:
      return Object.assign(
        {},
        state,
        payload,
        {
          queryConditions: { ...state.queryConditions, roomName: payload.list[0].roomName },
        },
        {
          loading: false,
        }
      );
    case UPDATA_ACTIVITY_INFO:
      return Object.assign({}, state, { currentActivityInfo: { name: payload } });
    case RESET_REPORT_PARAM:
      return Object.assign({}, initialState);
    default:
      return state;
  }
}
